<template>
  <div>
    <!--固定头部-->
    <nav-bar />
    <div class="box">
      <div class="content">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from '@/views/nav'
export default {
  name: 'Log',
  components: { NavBar }
}
</script>
<style lang="scss" scoped>
// 标签hove效果
/deep/.el-tabs__item:hover {
  color: $base-color;
}
// 标签页选中颜色
/deep/.el-tabs__item.is-active {
  color: $base-color;
}
// 标签页下边边框
/deep/.el-tabs__active-bar {
  background-color: $base-color;
}
/deep/.el-form-item__content {
  line-height: 0;
}
// 登录注册按钮
/deep/.button {
  color: #fff;
  background-color: $base-color;
  width: 100%;
}
// 发送验证码按钮
/deep/.code-btn {
  width: 100%;
  border-color: $base-color;
  // background-color: $base-color;
  color: $base-color;
}
.box {
  background: url("../../assets/img/loginBack.png") no-repeat top;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    // height: 516px;
    width: 456px;
    background-color: #fefefe;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.15);
    border-radius: 6px 6px 0px 6px;
    padding: 35px;
  }
  /deep/.bottom {
    font-size: 14px;
    color: #333333;
    margin-top: 20px;
    // 去登陆 注册链接样式
    .login-reg-link {
      color: #333333;
      text-decoration: none;
    }
  }
}
</style>
